import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchMedia, fetchSocialPostsThunk } from 'slices/influencer/thunk';
import { AppDispatch, RootState } from 'store'
import MediaGrid from './MediaGrid';
import { Post } from 'types/influencer';
import SocialMediaGrid from './SocialMediaGrid';
import { SocialPost } from 'types/campaign/collaborations';

interface InfluencerPostsProps {
    socialAccountId: string,
     onMediaClick: (post: SocialPost) => void,
     sort?: string
}

const InfluencerPosts: React.FC<InfluencerPostsProps> = ({ socialAccountId, onMediaClick, sort='like_count' }) => {

    const dispatch: AppDispatch = useDispatch();

    const postsData = useSelector((state: RootState) => state.influencers.social_media[socialAccountId]?.FEED);

    const posts = postsData?.items ?? [];
    const page = postsData?.page ?? 1;
    const has_more = postsData?.has_more ?? true;
    const loading = useSelector((state: RootState) => state.influencers.mediaLoading);


    useEffect(() => {
        if (socialAccountId && sort)
            dispatch(fetchSocialPostsThunk({ page: 1, socialAccountId, type: 'FEED', sort }));
    }, [socialAccountId, sort])

    const nextPage = () => {
        if (has_more && socialAccountId) {
            const nextPageNumber = page + 1;
            dispatch(fetchSocialPostsThunk({ page: nextPageNumber, socialAccountId, type: 'FEED', sort }))
        }
    }

    return (
        <SocialMediaGrid onGridItemClick={onMediaClick} media={posts} onNextPage={nextPage} has_more={has_more} contentLoading={loading} />
    )
}

export default InfluencerPosts